






































































import Vue, { PropOptions } from 'vue';
import * as validation from '@/personal/validation';
import * as NOCArray from '@/personal/array';
import { ISelectOption } from '@/class/models/typed/wild';
import SelectBox from '@/components/util/SelectBox.vue';

export interface IVariableInput extends validation.IPValidation {
  type: 'text' | 'number' | 'time' | 'date' | 'radio' | 'select' | 'textarea' | 'password' ;
  disabled?: boolean;
  class?: string;
  step?: number;
  autoComplete?: string;
}

export const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  TIME: 'time',
  DATE: 'date',
  RADIO: 'radio',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
};

export const checkValue = validation.checkValue;
export const checkValues = validation.checkValues;
export const CHECK_TYPE = validation.CHECK_TYPE;

export default Vue.extend({
  name: 'VariableInput',
  components: {
    SelectBox,
  },
  props: ['value', 'item'],
  data() {
    return {
      data: '',
    };
  },
  mounted() {
    this.item.error = '';
  },
  computed: {
    getOptionsText() {
      return NOCArray.getOptionsText;
    },
  },
  methods: {
    onInput(value: any) {
      this.$emit('input', value);
    },
    onRadioInput(value: string) {
      this.$emit('input', Number(value));
    },
    onChange(value: any) {
      validation.checkValue(value, this.item);
    },
    onSelectChange(value: any) {
      this.$emit('input', value);
    },
  },
});
